import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Modal, Button, Form } from "react-bootstrap";
import localforage from "localforage";
import L from "leaflet";
import * as turf from "@turf/turf"; // for area + centroid

// Fix default Leaflet icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// FlyTo helper
function FlyToMarker({ position }) {
  const map = useMap();
  if (position) map.flyTo(position, 18);
  return null;
}

export default function NolliMapWithModal({ place = "kaligayahan quezon city" }) {
  const [publicGeo, setPublicGeo] = useState(null);
  const [privateGeo, setPrivateGeo] = useState(null);
  const [markerPos, setMarkerPos] = useState(null);
  const [address, setAddress] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(null);
  const [ownerInput, setOwnerInput] = useState("");
  const [showBaseMap, setShowBaseMap] = useState(true);

  // Fetch Nolli GeoJSON
// Fetch Nolli GeoJSON
useEffect(() => {
  const q = encodeURIComponent(place);

  localforage.getItem(`nolli_${place}`).then((cached) => {
    if (cached) {
      setPublicGeo(cached.public);
      setPrivateGeo(cached.private);
      return;
    }

fetch(`${process.env.REACT_APP_API_URL}/nolli/?place=${q}&road_buffer=5`)
  .then((r) => r.text()) // get raw text
  .then((txt) => {
    // 🔹 replace invalid NaN with null
    const safeText = txt.replace(/\bNaN\b/g, "null");
    return JSON.parse(safeText);
  })
  .then((data) => {
    if (data.public) setPublicGeo(data.public);
    if (data.private) setPrivateGeo(data.private);
    localforage.setItem(`nolli_${place}`, data);
  })
  .catch((err) => console.error("Failed to load GeoJSON:", err));

  });


  
}, [place]);

  // Search address
  const handleSearch = async () => {
    if (!address) return;
    const q = encodeURIComponent(address);
    const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${q}`);
    const data = await res.json();
    if (data && data.length > 0) {
      const lat = parseFloat(data[0].lat);
      const lon = parseFloat(data[0].lon);
      setMarkerPos([lat, lon]);
    } else {
      alert("Address not found");
    }
  };

  // Styles
  const publicStyle = (feature) => {
    const cls = feature.properties.class;
    const colorMap = {
      school: "#FFD700",
      hospital: "#FF6347",
      library: "#1E90FF",
      townhall: "#32CD32",
      market: "#FF69B4",
      public: "#CCCCCC",
    };
    return {
      color: colorMap[cls] || "#AAAAAA",
      weight: 0.5,
      fillColor: colorMap[cls] || "#AAAAAA",
      fillOpacity: 0.7,
      interactive: true,
    };
  };

  const privateStyle = () => ({
    color: "#000000",
    weight: 0.5,
    fillColor: "#000000",
    fillOpacity: 0.7,
    interactive: true,
  });

  // Handlers
  const onEachFeature = (feature, layer, isPublic = true) => {
    const baseStyle = isPublic ? publicStyle(feature) : privateStyle(feature);

    layer.on({
      mouseover: (e) => e.target.setStyle({ weight: 2, fillOpacity: 1, }), //fillColor: "red",
      mouseout: (e) => e.target.setStyle(baseStyle),
      click: (e) => {

        // change polygon to red
      e.target.setStyle({
        color: "red",
        fillColor: "red",
        weight: 2,
         fillOpacity: 1
      });

        setCurrentFeature(feature);
        setOwnerInput(feature.properties.owner || "");
        setShowModal(true);
      },
    });
  };

  // Save owner
  const handleSaveOwner = async () => {
    if (!currentFeature) return;
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/tag_owner/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          building_id: currentFeature.properties.id,
          owner: ownerInput,
        }),
      });
      currentFeature.properties.owner = ownerInput;
      alert("Owner saved!");
      setShowModal(false);
    } catch (err) {
      console.error(err);
      alert("Failed to save owner");
    }
  };

  // Helper to extract computed details
  // Helper to extract computed details
const getFeatureDetails = (feature) => {
  if (!feature) return {};

  const geom = feature.geometry;
  let centroid = null;
  let area = null;

  try {
    centroid = turf.centroid(geom).geometry.coordinates;
    area = turf.area(geom); // in sqm
  } catch (e) {
    console.warn("Geometry calculation failed", e);
  }

  return {
    lat: centroid ? centroid[1].toFixed(6) : null,
    lon: centroid ? centroid[0].toFixed(6) : null,
    area: area ? area.toFixed(2) : null,
    name: feature.properties.name || null,
    owner: feature.properties.owner || null,
    floors: feature.properties["building:levels"] || null,
    type:
      feature.properties.amenity ||
      feature.properties.shop ||
      feature.properties.building ||
      null,
  };
};


  return (
    <div>
      {/* Controls */}
      <input
        type="text"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        placeholder="Enter address"
      />
      <button onClick={handleSearch}>Search</button>
      <button onClick={() => setMarkerPos(null)}>Clear Marker</button>
      <button type="button" onClick={() => setShowBaseMap((prev) => !prev)}>
        {showBaseMap ? "Hide Base Map" : "Show Base Map"}
      </button>

      {/* Map */}
      <MapContainer
        center={[14.783, 120.933]}
        zoom={14}
        style={{ height: "80vh", width: "100%" }}
      >
        {showBaseMap && (
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        )}
        {publicGeo && (
          <GeoJSON
            data={publicGeo}
             style={publicStyle}
            onEachFeature={(f, l) => onEachFeature(f, l, true)}
          />
        )}
        {privateGeo && (
          <GeoJSON
            data={privateGeo}
             style={privateStyle}
            onEachFeature={(f, l) => onEachFeature(f, l, false)}
          />
        )}
        {markerPos && (
          <Marker position={markerPos}>
            <Popup>{address}</Popup>
          </Marker>
        )}
        {markerPos && <FlyToMarker position={markerPos} />}
      </MapContainer>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Feature Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  {currentFeature && (() => {
    const details = getFeatureDetails(currentFeature);
    return (
     <>
  {details.lat && details.lon && (
    <p>
      <b>Lat:</b> {details.lat}, <b>Lon:</b> {details.lon}
    </p>
  )}
  {details.area && (
    <p>
      <b>Area:</b> {details.area} m²
    </p>
  )}
  {details.name && (
    <p>
      <b>Building Name:</b> {details.name}
    </p>
  )}
  {details.floors && (
    <p>
      <b>Floors:</b> {details.floors}
    </p>
  )}
  {details.type && (
    <p>
      <b>Type:</b> {details.type}
    </p>
  )}
  
    <p>
      <b>Block No:</b> {details?.block_no}
    </p>
  
 
    <p>
      <b>Lot No:</b> {details?.lot_no}
    </p>

  {details.address && (
    <p>
      <b>Address:</b> {details.address}
    </p>
  )}
        {currentFeature.properties.class === "private" ? (
          <Form>
            <Form.Group>
              <Form.Label>Owner Name</Form.Label>
              <Form.Control
                type="text"
                value={ownerInput}
                onChange={(e) => setOwnerInput(e.target.value)}
                placeholder="Enter owner name"
              />
            </Form.Group>
          </Form>
        ) : (
          details.owner && (
            <p>
              <b>Owner:</b> {details.owner}
            </p>
          )
        )}

        <h6 className="mt-3">All Properties:</h6>
        <ul style={{ maxHeight: "200px", overflowY: "auto" }}>
          {Object.entries(currentFeature.properties)
            .filter(([_, v]) => v !== null && v !== "" && v !== undefined) // 🔹 filter out invalid
            .map(([k, v]) => (
              <li key={k}>
                <b>{k}</b>: {String(v)}
              </li>
            ))}
        </ul>

      </>
    );
  })()}
</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          {currentFeature?.properties.class === "private" && (
            <Button variant="primary" onClick={handleSaveOwner}>
              Save Owner
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}
